import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  I18NLocaleCode: any;
  JSON: any;
  PageContentSectionsDynamicZoneInput: any;
  Upload: any;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentElementsDataTileGridItem = {
  __typename?: 'ComponentElementsDataTileGridItem';
  Image: UploadFileEntityResponse;
  Link: Scalars['String'];
  MobileImage?: Maybe<UploadFileEntityResponse>;
  Size: Enum_Componentelementsdatatilegriditem_Size;
  Text: Scalars['String'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsDataTileGridItemFiltersInput = {
  Link?: InputMaybe<StringFilterInput>;
  Size?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsDataTileGridItemFiltersInput>>>;
  not?: InputMaybe<ComponentElementsDataTileGridItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsDataTileGridItemFiltersInput>>>;
};

export type ComponentElementsFaqItem = {
  __typename?: 'ComponentElementsFaqItem';
  Answer: Scalars['String'];
  Question: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsFaqItemFiltersInput = {
  Answer?: InputMaybe<StringFilterInput>;
  Question?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsFaqItemFiltersInput>>>;
  not?: InputMaybe<ComponentElementsFaqItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsFaqItemFiltersInput>>>;
};

export type ComponentElementsFeaturesScrollItem = {
  __typename?: 'ComponentElementsFeaturesScrollItem';
  Background: Scalars['String'];
  ButtonDisabled: Scalars['Boolean'];
  ButtonLink: Scalars['String'];
  ButtonText: Scalars['String'];
  Image: UploadFileEntityResponse;
  MobileImage?: Maybe<UploadFileEntityResponse>;
  Text: Scalars['String'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsFeaturesScrollItemFiltersInput = {
  Background?: InputMaybe<StringFilterInput>;
  ButtonDisabled?: InputMaybe<BooleanFilterInput>;
  ButtonLink?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsFeaturesScrollItemFiltersInput>>>;
  not?: InputMaybe<ComponentElementsFeaturesScrollItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsFeaturesScrollItemFiltersInput>>>;
};

export type ComponentElementsLibraryItem = {
  __typename?: 'ComponentElementsLibraryItem';
  Background: Scalars['String'];
  ButtonLink: Scalars['String'];
  ButtonTitle: Scalars['String'];
  Image: UploadFileEntityResponse;
  IsFullWidth?: Maybe<Scalars['Boolean']>;
  Text: Scalars['String'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsLibraryItemFiltersInput = {
  Background?: InputMaybe<StringFilterInput>;
  ButtonLink?: InputMaybe<StringFilterInput>;
  ButtonTitle?: InputMaybe<StringFilterInput>;
  IsFullWidth?: InputMaybe<BooleanFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsLibraryItemFiltersInput>>>;
  not?: InputMaybe<ComponentElementsLibraryItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsLibraryItemFiltersInput>>>;
};

export type ComponentElementsLogoBox = {
  __typename?: 'ComponentElementsLogoBox';
  LogoImage: UploadFileEntityResponse;
  LogoLink?: Maybe<Scalars['String']>;
  LogoName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentElementsLogoBoxFiltersInput = {
  LogoLink?: InputMaybe<StringFilterInput>;
  LogoName?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsLogoBoxFiltersInput>>>;
  not?: InputMaybe<ComponentElementsLogoBoxFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsLogoBoxFiltersInput>>>;
};

export type ComponentElementsParallexCover = {
  __typename?: 'ComponentElementsParallexCover';
  Cover?: Maybe<UploadFileEntityResponse>;
  Speed: Scalars['Int'];
  X: Scalars['Int'];
  Y: Scalars['Int'];
  id: Scalars['ID'];
};

export type ComponentElementsParallexCoverFiltersInput = {
  Speed?: InputMaybe<IntFilterInput>;
  X?: InputMaybe<IntFilterInput>;
  Y?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsParallexCoverFiltersInput>>>;
  not?: InputMaybe<ComponentElementsParallexCoverFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsParallexCoverFiltersInput>>>;
};

export type ComponentElementsPlatformSelector = {
  __typename?: 'ComponentElementsPlatformSelector';
  Background?: Maybe<Scalars['String']>;
  Description: Scalars['String'];
  Image: UploadFileEntityResponse;
  Link?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsPlatformSelectorFiltersInput = {
  Background?: InputMaybe<StringFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsPlatformSelectorFiltersInput>>>;
  not?: InputMaybe<ComponentElementsPlatformSelectorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsPlatformSelectorFiltersInput>>>;
};

export type ComponentElementsPricingPlanFeature = {
  __typename?: 'ComponentElementsPricingPlanFeature';
  Name: Scalars['String'];
  StrikedOut?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type ComponentElementsPricingPlanFeatureFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  StrikedOut?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsPricingPlanFeatureFiltersInput>>>;
  not?: InputMaybe<ComponentElementsPricingPlanFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsPricingPlanFeatureFiltersInput>>>;
};

export type ComponentElementsPricingPlanFeatureInput = {
  Name?: InputMaybe<Scalars['String']>;
  StrikedOut?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ComponentElementsRunnerGenre = {
  __typename?: 'ComponentElementsRunnerGenre';
  Genre: Scalars['String'];
  Image: UploadFileEntityResponse;
  id: Scalars['ID'];
};

export type ComponentElementsRunnerGenreFiltersInput = {
  Genre?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsRunnerGenreFiltersInput>>>;
  not?: InputMaybe<ComponentElementsRunnerGenreFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsRunnerGenreFiltersInput>>>;
};

export type ComponentElementsSlidingCover = {
  __typename?: 'ComponentElementsSlidingCover';
  cover: UploadFileEntityResponse;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
};

export type ComponentElementsSlidingCoverFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentElementsSlidingCoverFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentElementsSlidingCoverFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsSlidingCoverFiltersInput>>>;
};

export type ComponentElementsTracksParallaxItem = {
  __typename?: 'ComponentElementsTracksParallaxItem';
  Genre: Scalars['String'];
  Image: UploadFileEntityResponse;
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentElementsTracksParallaxItemFiltersInput = {
  Genre?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentElementsTracksParallaxItemFiltersInput>>>;
  not?: InputMaybe<ComponentElementsTracksParallaxItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentElementsTracksParallaxItemFiltersInput>>>;
};

export type ComponentLinksButton = {
  __typename?: 'ComponentLinksButton';
  dark: Scalars['Boolean'];
  fullWidth: Scalars['Boolean'];
  id: Scalars['ID'];
  page?: Maybe<PageEntityResponse>;
  text: Scalars['String'];
  transparent?: Maybe<Scalars['Boolean']>;
};

export type ComponentLinksButtonLink = {
  __typename?: 'ComponentLinksButtonLink';
  id: Scalars['ID'];
  newTab?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentlinksbuttonlink_Type>;
  url?: Maybe<Scalars['String']>;
};

export type ComponentLinksLink = {
  __typename?: 'ComponentLinksLink';
  id: Scalars['ID'];
  newTab?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ComponentMetaColorPicker = {
  __typename?: 'ComponentMetaColorPicker';
  color: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentMetaMetadata = {
  __typename?: 'ComponentMetaMetadata';
  FacebookPixeliD?: Maybe<Scalars['String']>;
  GoogleTagManagerID?: Maybe<Scalars['String']>;
  ShowZendeskChat?: Maybe<Scalars['Boolean']>;
  ZendeskChatTagId?: Maybe<Scalars['String']>;
  accent?: Maybe<Scalars['String']>;
  favicon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  klaviyoApiKey?: Maybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  metaTitle: Scalars['String'];
  shareImage?: Maybe<UploadFileEntityResponse>;
  twitterCardType?: Maybe<Enum_Componentmetametadata_Twittercardtype>;
  twitterUsername?: Maybe<Scalars['String']>;
};

export type ComponentMetaMetadataFiltersInput = {
  FacebookPixeliD?: InputMaybe<StringFilterInput>;
  GoogleTagManagerID?: InputMaybe<StringFilterInput>;
  ShowZendeskChat?: InputMaybe<BooleanFilterInput>;
  ZendeskChatTagId?: InputMaybe<StringFilterInput>;
  accent?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMetaMetadataFiltersInput>>>;
  klaviyoApiKey?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMetaMetadataFiltersInput>>>;
  twitterCardType?: InputMaybe<StringFilterInput>;
  twitterUsername?: InputMaybe<StringFilterInput>;
};

export type ComponentMetaMetadataInput = {
  FacebookPixeliD?: InputMaybe<Scalars['String']>;
  GoogleTagManagerID?: InputMaybe<Scalars['String']>;
  ShowZendeskChat?: InputMaybe<Scalars['Boolean']>;
  ZendeskChatTagId?: InputMaybe<Scalars['String']>;
  accent?: InputMaybe<Scalars['String']>;
  favicon?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  klaviyoApiKey?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  shareImage?: InputMaybe<Scalars['ID']>;
  twitterCardType?: InputMaybe<Enum_Componentmetametadata_Twittercardtype>;
  twitterUsername?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionsCallToAction = {
  __typename?: 'ComponentSectionsCallToAction';
  action: ComponentLinksButton;
  background: Scalars['String'];
  bigTitle: Scalars['String'];
  id: Scalars['ID'];
  image: UploadFileEntityResponse;
  smallTitle: Scalars['String'];
};

export type ComponentSectionsContentHero = {
  __typename?: 'ComponentSectionsContentHero';
  BigMainImage?: Maybe<UploadFileEntityResponse>;
  BigMainImageMobile?: Maybe<UploadFileEntityResponse>;
  Button?: Maybe<ComponentLinksButton>;
  Button2?: Maybe<ComponentLinksButton>;
  FullWidthBg?: Maybe<UploadFileEntityResponse>;
  StyledTitle: Scalars['Boolean'];
  TitleBig?: Maybe<Scalars['String']>;
  TitleSmall?: Maybe<Scalars['String']>;
  UseAppStoreLinks?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type ComponentSectionsDataTilesGrid = {
  __typename?: 'ComponentSectionsDataTilesGrid';
  Tiles: Array<Maybe<ComponentElementsDataTileGridItem>>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};


export type ComponentSectionsDataTilesGridTilesArgs = {
  filters?: InputMaybe<ComponentElementsDataTileGridItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsFaq = {
  __typename?: 'ComponentSectionsFaq';
  BigTitle: Scalars['String'];
  SmallTitle: Scalars['String'];
  id: Scalars['ID'];
  questions: Array<Maybe<ComponentElementsFaqItem>>;
};


export type ComponentSectionsFaqQuestionsArgs = {
  filters?: InputMaybe<ComponentElementsFaqItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsFeaturesCards = {
  __typename?: 'ComponentSectionsFeaturesCards';
  BigTitle: Scalars['String'];
  BottomLeftCard: ComponentElementsDataTileGridItem;
  BottomRight: ComponentElementsDataTileGridItem;
  SmallTitle: Scalars['String'];
  TopLeftCard: ComponentElementsDataTileGridItem;
  TopRightCard: ComponentElementsDataTileGridItem;
  id: Scalars['ID'];
};

export type ComponentSectionsFeaturesScrollSection = {
  __typename?: 'ComponentSectionsFeaturesScrollSection';
  Features: Array<Maybe<ComponentElementsFeaturesScrollItem>>;
  ImageType: Enum_Componentsectionsfeaturesscrollsection_Imagetype;
  InnerTitle?: Maybe<Scalars['String']>;
  KeepSliderOnMobile?: Maybe<Scalars['Boolean']>;
  MainTitle?: Maybe<Scalars['String']>;
  SideLineColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type ComponentSectionsFeaturesScrollSectionFeaturesArgs = {
  filters?: InputMaybe<ComponentElementsFeaturesScrollItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsForgotPassword = {
  __typename?: 'ComponentSectionsForgotPassword';
  Image: UploadFileEntityResponse;
  ResetImage?: Maybe<UploadFileEntityResponse>;
  ResetText?: Maybe<Scalars['String']>;
  ResetTitle?: Maybe<Scalars['String']>;
  SmallText?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentSectionsFormAndImage = {
  __typename?: 'ComponentSectionsFormAndImage';
  ForceRedirectTo?: Maybe<Scalars['String']>;
  From?: Maybe<Scalars['String']>;
  Image: UploadFileEntityResponse;
  Layout: Enum_Componentsectionsformandimage_Layout;
  LoginLink?: Maybe<Scalars['String']>;
  MobileImage?: Maybe<UploadFileEntityResponse>;
  OfferDisclaimer?: Maybe<Scalars['String']>;
  PromoCode?: Maybe<Scalars['String']>;
  RecaptchaSiteToken?: Maybe<Scalars['String']>;
  SmallText?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Type: Enum_Componentsectionsformandimage_Type;
  id: Scalars['ID'];
};

export type ComponentSectionsGenresRunner = {
  __typename?: 'ComponentSectionsGenresRunner';
  FirstRow: Array<Maybe<ComponentElementsRunnerGenre>>;
  Headline?: Maybe<Scalars['String']>;
  SecondRow?: Maybe<Array<Maybe<ComponentElementsRunnerGenre>>>;
  ThirdRow?: Maybe<Array<Maybe<ComponentElementsRunnerGenre>>>;
  id: Scalars['ID'];
};


export type ComponentSectionsGenresRunnerFirstRowArgs = {
  filters?: InputMaybe<ComponentElementsRunnerGenreFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentSectionsGenresRunnerSecondRowArgs = {
  filters?: InputMaybe<ComponentElementsRunnerGenreFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentSectionsGenresRunnerThirdRowArgs = {
  filters?: InputMaybe<ComponentElementsRunnerGenreFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsGetTheApp = {
  __typename?: 'ComponentSectionsGetTheApp';
  Background: Scalars['String'];
  BigTitle: Scalars['String'];
  Image: UploadFileEntityResponse;
  SmallTitle: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentSectionsGetTheAppWithIcon = {
  __typename?: 'ComponentSectionsGetTheAppWithIcon';
  Icon?: Maybe<UploadFileEntityResponse>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentSectionsGiveaway = {
  __typename?: 'ComponentSectionsGiveaway';
  GiveawaySlug?: Maybe<Scalars['String']>;
  SignupLink?: Maybe<PageEntityResponse>;
  id: Scalars['ID'];
};

export type ComponentSectionsHero = {
  __typename?: 'ComponentSectionsHero';
  ActionTwo?: Maybe<ComponentLinksButton>;
  CubeBackgroundColor: ComponentMetaColorPicker;
  action: ComponentLinksButton;
  id: Scalars['ID'];
  isPromotionForm?: Maybe<Scalars['Boolean']>;
  marketingPlatform?: Maybe<Enum_Componentsectionshero_Marketingplatform>;
  marketingType?: Maybe<Scalars['String']>;
  mobilePicture?: Maybe<UploadFileEntityResponse>;
  mobileTitle?: Maybe<Scalars['String']>;
  picture: UploadFileEntityResponse;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentSectionsImageWithParallax = {
  __typename?: 'ComponentSectionsImageWithParallax';
  Covers: Array<Maybe<ComponentElementsParallexCover>>;
  MainImage?: Maybe<UploadFileEntityResponse>;
  MainImageMobile?: Maybe<UploadFileEntityResponse>;
  MiniTitle?: Maybe<Scalars['String']>;
  SectionTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type ComponentSectionsImageWithParallaxCoversArgs = {
  filters?: InputMaybe<ComponentElementsParallexCoverFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsLibrariesSection = {
  __typename?: 'ComponentSectionsLibrariesSection';
  Items: Array<Maybe<ComponentElementsLibraryItem>>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};


export type ComponentSectionsLibrariesSectionItemsArgs = {
  filters?: InputMaybe<ComponentElementsLibraryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsLogoBoxes = {
  __typename?: 'ComponentSectionsLogoBoxes';
  LogoBoxtitle?: Maybe<Scalars['String']>;
  Logos: Array<Maybe<ComponentElementsLogoBox>>;
  id: Scalars['ID'];
};


export type ComponentSectionsLogoBoxesLogosArgs = {
  filters?: InputMaybe<ComponentElementsLogoBoxFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsPartnersForm = {
  __typename?: 'ComponentSectionsPartnersForm';
  BigTitle: Scalars['String'];
  MainImage?: Maybe<UploadFileEntityResponse>;
  MobileImage?: Maybe<UploadFileEntityResponse>;
  SmallText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentSectionsPlatformsSelector = {
  __typename?: 'ComponentSectionsPlatformsSelector';
  Platforms: Array<Maybe<ComponentElementsPlatformSelector>>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};


export type ComponentSectionsPlatformsSelectorPlatformsArgs = {
  filters?: InputMaybe<ComponentElementsPlatformSelectorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsPricing = {
  __typename?: 'ComponentSectionsPricing';
  SmallSectionTitle?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  id: Scalars['ID'];
  pricing_categories?: Maybe<PricingCategoryRelationResponseCollection>;
  pricing_plans?: Maybe<PricingPlanRelationResponseCollection>;
};


export type ComponentSectionsPricingPricing_CategoriesArgs = {
  filters?: InputMaybe<PricingCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentSectionsPricingPricing_PlansArgs = {
  filters?: InputMaybe<PricingPlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsRichText = {
  __typename?: 'ComponentSectionsRichText';
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type ComponentSectionsSlidingCoversHero = {
  __typename?: 'ComponentSectionsSlidingCoversHero';
  Covers: Array<Maybe<ComponentElementsSlidingCover>>;
  Library: Enum_Componentsectionsslidingcovershero_Library;
  MainButton: ComponentLinksButton;
  MainTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type ComponentSectionsSlidingCoversHeroCoversArgs = {
  filters?: InputMaybe<ComponentElementsSlidingCoverFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsTestimonialsSlider = {
  __typename?: 'ComponentSectionsTestimonialsSlider';
  Title: Scalars['String'];
  id: Scalars['ID'];
  testimonials?: Maybe<TestimonialRelationResponseCollection>;
};


export type ComponentSectionsTestimonialsSliderTestimonialsArgs = {
  filters?: InputMaybe<TestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsTextAndButtonWithParallax = {
  __typename?: 'ComponentSectionsTextAndButtonWithParallax';
  Button?: Maybe<ComponentLinksButton>;
  Covers: Array<Maybe<ComponentElementsParallexCover>>;
  Text: Scalars['String'];
  id: Scalars['ID'];
};


export type ComponentSectionsTextAndButtonWithParallaxCoversArgs = {
  filters?: InputMaybe<ComponentElementsParallexCoverFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsTextAndImage = {
  __typename?: 'ComponentSectionsTextAndImage';
  BigText: Scalars['String'];
  Direction: Enum_Componentsectionstextandimage_Direction;
  Image: UploadFileEntityResponse;
  ImageSticked: Scalars['Boolean'];
  MobileImage?: Maybe<UploadFileEntityResponse>;
  SmallDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentSectionsTracksParallaxBox = {
  __typename?: 'ComponentSectionsTracksParallaxBox';
  Items: Array<Maybe<ComponentElementsTracksParallaxItem>>;
  Title: Scalars['String'];
  id: Scalars['ID'];
};


export type ComponentSectionsTracksParallaxBoxItemsArgs = {
  filters?: InputMaybe<ComponentElementsTracksParallaxItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export enum Enum_Componentelementsdatatilegriditem_Size {
  Big = 'Big',
  Small = 'Small'
}

export enum Enum_Componentlinksbuttonlink_Type {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum Enum_Componentmetametadata_Twittercardtype {
  App = 'app',
  Player = 'player',
  Summary = 'summary',
  SummaryLargeImage = 'summary_large_image'
}

export enum Enum_Componentsectionsfeaturesscrollsection_Imagetype {
  Normal = 'Normal',
  Stretch = 'Stretch'
}

export enum Enum_Componentsectionsformandimage_Layout {
  BackgroundMedia = 'Background_Media',
  FullImage = 'Full_Image',
  Stats = 'Stats'
}

export enum Enum_Componentsectionsformandimage_Type {
  Login = 'Login',
  Register = 'Register'
}

export enum Enum_Componentsectionshero_Marketingplatform {
  Artist = 'artist',
  Create = 'create',
  Latino = 'latino',
  Stream = 'stream',
  Supreme = 'supreme',
  Sync = 'sync'
}

export enum Enum_Componentsectionsslidingcovershero_Library {
  Create = 'Create',
  Latino = 'Latino',
  Supreme = 'Supreme'
}

export enum Enum_Componentsectionstextandimage_Direction {
  Left = 'Left',
  Right = 'Right'
}

export enum Enum_Page_Redirectiontarget {
  Artist = 'Artist',
  Create = 'Create',
  Supreme = 'Supreme'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = ComponentElementsDataTileGridItem | ComponentElementsFaqItem | ComponentElementsFeaturesScrollItem | ComponentElementsLibraryItem | ComponentElementsLogoBox | ComponentElementsParallexCover | ComponentElementsPlatformSelector | ComponentElementsPricingPlanFeature | ComponentElementsRunnerGenre | ComponentElementsSlidingCover | ComponentElementsTracksParallaxItem | ComponentLinksButton | ComponentLinksButtonLink | ComponentLinksLink | ComponentMetaColorPicker | ComponentMetaMetadata | ComponentSectionsCallToAction | ComponentSectionsContentHero | ComponentSectionsDataTilesGrid | ComponentSectionsFaq | ComponentSectionsFeaturesCards | ComponentSectionsFeaturesScrollSection | ComponentSectionsForgotPassword | ComponentSectionsFormAndImage | ComponentSectionsGenresRunner | ComponentSectionsGetTheApp | ComponentSectionsGetTheAppWithIcon | ComponentSectionsGiveaway | ComponentSectionsHero | ComponentSectionsImageWithParallax | ComponentSectionsLibrariesSection | ComponentSectionsLogoBoxes | ComponentSectionsPartnersForm | ComponentSectionsPlatformsSelector | ComponentSectionsPricing | ComponentSectionsRichText | ComponentSectionsSlidingCoversHero | ComponentSectionsTestimonialsSlider | ComponentSectionsTextAndButtonWithParallax | ComponentSectionsTextAndImage | ComponentSectionsTracksParallaxBox | Global | I18NLocale | Page | PricingCategory | PricingPlan | Testimonial | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Global = {
  __typename?: 'Global';
  Copyrights?: Maybe<Scalars['String']>;
  GooglePlayStoreLink?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  iOSStoreLink?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<GlobalRelationResponseCollection>;
  metaTitleSuffix: Scalars['String'];
  metadata?: Maybe<ComponentMetaMetadata>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GlobalEntity = {
  __typename?: 'GlobalEntity';
  attributes?: Maybe<Global>;
  id?: Maybe<Scalars['ID']>;
};

export type GlobalEntityResponse = {
  __typename?: 'GlobalEntityResponse';
  data?: Maybe<GlobalEntity>;
};

export type GlobalInput = {
  Copyrights?: InputMaybe<Scalars['String']>;
  GooglePlayStoreLink?: InputMaybe<Scalars['String']>;
  iOSStoreLink?: InputMaybe<Scalars['String']>;
  metaTitleSuffix?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
};

export type GlobalRelationResponseCollection = {
  __typename?: 'GlobalRelationResponseCollection';
  data: Array<GlobalEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createGlobalLocalization?: Maybe<GlobalEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createPageLocalization?: Maybe<PageEntityResponse>;
  createPricingCategory?: Maybe<PricingCategoryEntityResponse>;
  createPricingPlan?: Maybe<PricingPlanEntityResponse>;
  createPricingPlanLocalization?: Maybe<PricingPlanEntityResponse>;
  createTestimonial?: Maybe<TestimonialEntityResponse>;
  createTestimonialLocalization?: Maybe<TestimonialEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteGlobal?: Maybe<GlobalEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deletePricingCategory?: Maybe<PricingCategoryEntityResponse>;
  deletePricingPlan?: Maybe<PricingPlanEntityResponse>;
  deleteTestimonial?: Maybe<TestimonialEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateFileInfo: UploadFileEntityResponse;
  updateGlobal?: Maybe<GlobalEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updatePricingCategory?: Maybe<PricingCategoryEntityResponse>;
  updatePricingPlan?: Maybe<PricingPlanEntityResponse>;
  updateTestimonial?: Maybe<TestimonialEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateGlobalLocalizationArgs = {
  data?: InputMaybe<GlobalInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageArgs = {
  data: PageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageLocalizationArgs = {
  data?: InputMaybe<PageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePricingCategoryArgs = {
  data: PricingCategoryInput;
};


export type MutationCreatePricingPlanArgs = {
  data: PricingPlanInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePricingPlanLocalizationArgs = {
  data?: InputMaybe<PricingPlanInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTestimonialArgs = {
  data: TestimonialInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTestimonialLocalizationArgs = {
  data?: InputMaybe<TestimonialInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePricingCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePricingPlanArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTestimonialArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateGlobalArgs = {
  data: GlobalInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePricingCategoryArgs = {
  data: PricingCategoryInput;
  id: Scalars['ID'];
};


export type MutationUpdatePricingPlanArgs = {
  data: PricingPlanInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTestimonialArgs = {
  data: TestimonialInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  externalPath?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  master?: Maybe<Scalars['Int']>;
  menuAttached: Scalars['Boolean'];
  order: Scalars['Int'];
  parent?: Maybe<NavigationItem>;
  path?: Maybe<Scalars['String']>;
  related?: Maybe<NavigationItemRelatedData>;
  title: Scalars['String'];
  type: Scalars['String'];
  uiRouterKey: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type NavigationItemRelated = Page;

export type NavigationItemRelatedData = {
  __typename?: 'NavigationItemRelatedData';
  attributes?: Maybe<NavigationItemRelated>;
  id: Scalars['Int'];
};

export enum NavigationRenderType {
  Flat = 'FLAT',
  Rfr = 'RFR',
  Tree = 'TREE'
}

export type Page = {
  __typename?: 'Page';
  RedirectOnSubscription?: Maybe<Scalars['Boolean']>;
  RedirectionTarget?: Maybe<Enum_Page_Redirectiontarget>;
  ShowFooter: Scalars['Boolean'];
  ShowNavigation: Scalars['Boolean'];
  contentSections?: Maybe<Array<Maybe<PageContentSectionsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  publishedAt?: Maybe<Scalars['DateTime']>;
  shortName: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PageLocalizationsArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageContentSectionsDynamicZone = ComponentSectionsCallToAction | ComponentSectionsContentHero | ComponentSectionsDataTilesGrid | ComponentSectionsFaq | ComponentSectionsFeaturesCards | ComponentSectionsFeaturesScrollSection | ComponentSectionsForgotPassword | ComponentSectionsFormAndImage | ComponentSectionsGenresRunner | ComponentSectionsGetTheApp | ComponentSectionsGetTheAppWithIcon | ComponentSectionsGiveaway | ComponentSectionsHero | ComponentSectionsImageWithParallax | ComponentSectionsLibrariesSection | ComponentSectionsLogoBoxes | ComponentSectionsPartnersForm | ComponentSectionsPlatformsSelector | ComponentSectionsPricing | ComponentSectionsRichText | ComponentSectionsSlidingCoversHero | ComponentSectionsTestimonialsSlider | ComponentSectionsTextAndButtonWithParallax | ComponentSectionsTextAndImage | ComponentSectionsTracksParallaxBox | Error;

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  RedirectOnSubscription?: InputMaybe<BooleanFilterInput>;
  RedirectionTarget?: InputMaybe<StringFilterInput>;
  ShowFooter?: InputMaybe<BooleanFilterInput>;
  ShowNavigation?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  shortName?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  RedirectOnSubscription?: InputMaybe<Scalars['Boolean']>;
  RedirectionTarget?: InputMaybe<Enum_Page_Redirectiontarget>;
  ShowFooter?: InputMaybe<Scalars['Boolean']>;
  ShowNavigation?: InputMaybe<Scalars['Boolean']>;
  contentSections?: InputMaybe<Array<Scalars['PageContentSectionsDynamicZoneInput']>>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  shortName?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<PageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type PricingCategory = {
  __typename?: 'PricingCategory';
  Name: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  pricing_plans?: Maybe<PricingPlanRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PricingCategoryPricing_PlansArgs = {
  filters?: InputMaybe<PricingPlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PricingCategoryEntity = {
  __typename?: 'PricingCategoryEntity';
  attributes?: Maybe<PricingCategory>;
  id?: Maybe<Scalars['ID']>;
};

export type PricingCategoryEntityResponse = {
  __typename?: 'PricingCategoryEntityResponse';
  data?: Maybe<PricingCategoryEntity>;
};

export type PricingCategoryEntityResponseCollection = {
  __typename?: 'PricingCategoryEntityResponseCollection';
  data: Array<PricingCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type PricingCategoryFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PricingCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PricingCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PricingCategoryFiltersInput>>>;
  pricing_plans?: InputMaybe<PricingPlanFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PricingCategoryInput = {
  Name?: InputMaybe<Scalars['String']>;
  pricing_plans?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PricingCategoryRelationResponseCollection = {
  __typename?: 'PricingCategoryRelationResponseCollection';
  data: Array<PricingCategoryEntity>;
};

export type PricingPlan = {
  __typename?: 'PricingPlan';
  Badge?: Maybe<Scalars['String']>;
  BedgeBG?: Maybe<Scalars['String']>;
  ButtonLink: Scalars['String'];
  EverythingInText?: Maybe<Scalars['String']>;
  Features: Array<Maybe<ComponentElementsPricingPlanFeature>>;
  FirstMonthPrice?: Maybe<Scalars['String']>;
  MonthPrice: Scalars['Float'];
  Name?: Maybe<Scalars['String']>;
  ShowMonthly: Scalars['Boolean'];
  Title: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PricingPlanRelationResponseCollection>;
  pricing_category?: Maybe<PricingCategoryEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PricingPlanFeaturesArgs = {
  filters?: InputMaybe<ComponentElementsPricingPlanFeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PricingPlanLocalizationsArgs = {
  filters?: InputMaybe<PricingPlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PricingPlanEntity = {
  __typename?: 'PricingPlanEntity';
  attributes?: Maybe<PricingPlan>;
  id?: Maybe<Scalars['ID']>;
};

export type PricingPlanEntityResponse = {
  __typename?: 'PricingPlanEntityResponse';
  data?: Maybe<PricingPlanEntity>;
};

export type PricingPlanEntityResponseCollection = {
  __typename?: 'PricingPlanEntityResponseCollection';
  data: Array<PricingPlanEntity>;
  meta: ResponseCollectionMeta;
};

export type PricingPlanFiltersInput = {
  Badge?: InputMaybe<StringFilterInput>;
  BedgeBG?: InputMaybe<StringFilterInput>;
  ButtonLink?: InputMaybe<StringFilterInput>;
  EverythingInText?: InputMaybe<StringFilterInput>;
  Features?: InputMaybe<ComponentElementsPricingPlanFeatureFiltersInput>;
  FirstMonthPrice?: InputMaybe<StringFilterInput>;
  MonthPrice?: InputMaybe<FloatFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ShowMonthly?: InputMaybe<BooleanFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PricingPlanFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PricingPlanFiltersInput>;
  not?: InputMaybe<PricingPlanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PricingPlanFiltersInput>>>;
  pricing_category?: InputMaybe<PricingCategoryFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PricingPlanInput = {
  Badge?: InputMaybe<Scalars['String']>;
  BedgeBG?: InputMaybe<Scalars['String']>;
  ButtonLink?: InputMaybe<Scalars['String']>;
  EverythingInText?: InputMaybe<Scalars['String']>;
  Features?: InputMaybe<Array<InputMaybe<ComponentElementsPricingPlanFeatureInput>>>;
  FirstMonthPrice?: InputMaybe<Scalars['String']>;
  MonthPrice?: InputMaybe<Scalars['Float']>;
  Name?: InputMaybe<Scalars['String']>;
  ShowMonthly?: InputMaybe<Scalars['Boolean']>;
  Title?: InputMaybe<Scalars['String']>;
  pricing_category?: InputMaybe<Scalars['ID']>;
};

export type PricingPlanRelationResponseCollection = {
  __typename?: 'PricingPlanRelationResponseCollection';
  data: Array<PricingPlanEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  global?: Maybe<GlobalEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  pricingCategories?: Maybe<PricingCategoryEntityResponseCollection>;
  pricingCategory?: Maybe<PricingCategoryEntityResponse>;
  pricingPlan?: Maybe<PricingPlanEntityResponse>;
  pricingPlans?: Maybe<PricingPlanEntityResponseCollection>;
  renderNavigation: Array<Maybe<NavigationItem>>;
  renderNavigationChild: Array<Maybe<NavigationItem>>;
  testimonial?: Maybe<TestimonialEntityResponse>;
  testimonials?: Maybe<TestimonialEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPricingCategoriesArgs = {
  filters?: InputMaybe<PricingCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPricingCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPricingPlanArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPricingPlansArgs = {
  filters?: InputMaybe<PricingPlanFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRenderNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  navigationIdOrSlug: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NavigationRenderType>;
};


export type QueryRenderNavigationChildArgs = {
  childUiKey: Scalars['String'];
  id: Scalars['String'];
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<NavigationRenderType>;
};


export type QueryTestimonialArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryTestimonialsArgs = {
  filters?: InputMaybe<TestimonialFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  Image: UploadFileEntityResponse;
  Name: Scalars['String'];
  Sentence: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<TestimonialRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TestimonialLocalizationsArgs = {
  filters?: InputMaybe<TestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TestimonialEntity = {
  __typename?: 'TestimonialEntity';
  attributes?: Maybe<Testimonial>;
  id?: Maybe<Scalars['ID']>;
};

export type TestimonialEntityResponse = {
  __typename?: 'TestimonialEntityResponse';
  data?: Maybe<TestimonialEntity>;
};

export type TestimonialEntityResponseCollection = {
  __typename?: 'TestimonialEntityResponseCollection';
  data: Array<TestimonialEntity>;
  meta: ResponseCollectionMeta;
};

export type TestimonialFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  Sentence?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TestimonialFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<TestimonialFiltersInput>;
  not?: InputMaybe<TestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TestimonialFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TestimonialInput = {
  Image?: InputMaybe<Scalars['ID']>;
  Name?: InputMaybe<Scalars['String']>;
  Sentence?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
};

export type TestimonialRelationResponseCollection = {
  __typename?: 'TestimonialRelationResponseCollection';
  data: Array<TestimonialEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type FilePartsFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null };

export type GetGlobalQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode'];
}>;


export type GetGlobalQuery = { __typename?: 'Query', mainNavigation: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'Page', shortName: string } | null } | null, items?: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'Page', shortName: string } | null } | null } | null> | null } | null>, footerNavigation: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'Page', shortName: string } | null } | null, items?: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'Page', shortName: string } | null } | null } | null> | null } | null>, global?: { __typename?: 'GlobalEntityResponse', data?: { __typename?: 'GlobalEntity', id?: string | null, attributes?: { __typename?: 'Global', iOSStoreLink?: string | null, GooglePlayStoreLink?: string | null, metaTitleSuffix: string, Copyrights?: string | null, metadata?: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, twitterCardType?: Enum_Componentmetametadata_Twittercardtype | null, twitterUsername?: string | null, GoogleTagManagerID?: string | null, FacebookPixeliD?: string | null, klaviyoApiKey?: string | null, accent?: string | null, favicon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | null } | null } | null } | null };

export type GetPagesQueryVariables = Exact<{
  slug: Scalars['String'];
  publicationState: PublicationState;
}>;


export type GetPagesQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', slug?: string | null, ShowFooter: boolean, ShowNavigation: boolean, RedirectOnSubscription?: boolean | null, RedirectionTarget?: Enum_Page_Redirectiontarget | null, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, twitterCardType?: Enum_Componentmetametadata_Twittercardtype | null, twitterUsername?: string | null, FacebookPixeliD?: string | null, GoogleTagManagerID?: string | null, accent?: string | null, ShowZendeskChat?: boolean | null, ZendeskChatTagId?: string | null, favicon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null }, contentSections?: Array<{ __typename: 'ComponentSectionsCallToAction', bigTitle: string, smallTitle: string, background: string, action: { __typename?: 'ComponentLinksButton', text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null }, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | { __typename: 'ComponentSectionsContentHero', TitleBig?: string | null, TitleSmall?: string | null, StyledTitle: boolean, UseAppStoreLinks?: boolean | null, BigMainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, BigMainImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, FullWidthBg?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, Button?: { __typename?: 'ComponentLinksButton', text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null } | null, Button2?: { __typename?: 'ComponentLinksButton', text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null } | null } | { __typename: 'ComponentSectionsDataTilesGrid', Title: string, Tiles: Array<{ __typename?: 'ComponentElementsDataTileGridItem', Title: string, Link: string, Size: Enum_Componentelementsdatatilegriditem_Size, Text: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | null> } | { __typename: 'ComponentSectionsFaq', BigTitle: string, SmallTitle: string, questions: Array<{ __typename?: 'ComponentElementsFaqItem', Answer: string, Question: string } | null> } | { __typename: 'ComponentSectionsFeaturesCards', BigTitle: string, SmallTitle: string, TopLeftCard: { __typename?: 'ComponentElementsDataTileGridItem', Title: string, Text: string, Link: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null }, TopRightCard: { __typename?: 'ComponentElementsDataTileGridItem', Title: string, Text: string, Link: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null }, BottomLeftCard: { __typename?: 'ComponentElementsDataTileGridItem', Title: string, Text: string, Link: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null }, BottomRight: { __typename?: 'ComponentElementsDataTileGridItem', Title: string, Text: string, Link: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } } | { __typename: 'ComponentSectionsFeaturesScrollSection', InnerTitle?: string | null, ImageType: Enum_Componentsectionsfeaturesscrollsection_Imagetype, SideLineColor?: string | null, MainTitle?: string | null, KeepSliderOnMobile?: boolean | null, Features: Array<{ __typename?: 'ComponentElementsFeaturesScrollItem', Text: string, Title: string, Background: string, ButtonDisabled: boolean, ButtonLink: string, ButtonText: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | null> } | { __typename: 'ComponentSectionsForgotPassword', Title: string, ResetTitle?: string | null, SmallText?: string | null, ResetText?: string | null, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, ResetImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsFormAndImage', Layout: Enum_Componentsectionsformandimage_Layout, SmallText?: string | null, Title: string, Type: Enum_Componentsectionsformandimage_Type, PromoCode?: string | null, OfferDisclaimer?: string | null, From?: string | null, RecaptchaSiteToken?: string | null, LoginLink?: string | null, ForceRedirectTo?: string | null, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsGenresRunner', Headline?: string | null, FirstRow: Array<{ __typename?: 'ComponentElementsRunnerGenre', Genre: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null>, SecondRow?: Array<{ __typename?: 'ComponentElementsRunnerGenre', Genre: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> | null, ThirdRow?: Array<{ __typename?: 'ComponentElementsRunnerGenre', Genre: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> | null } | { __typename: 'ComponentSectionsGetTheApp', Background: string, SmallTitle: string, BigTitle: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | { __typename: 'ComponentSectionsGetTheAppWithIcon', Title: string, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsGiveaway', GiveawaySlug?: string | null, SignupLink?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null } | { __typename: 'ComponentSectionsHero', id: string, isPromotionForm?: boolean | null, marketingPlatform?: Enum_Componentsectionshero_Marketingplatform | null, marketingType?: string | null, title: string, text: string, mobileTitle?: string | null, action: { __typename?: 'ComponentLinksButton', transparent?: boolean | null, text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null }, ActionTwo?: { __typename?: 'ComponentLinksButton', transparent?: boolean | null, text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null } | null, CubeBackgroundColor: { __typename?: 'ComponentMetaColorPicker', color: string }, picture: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, mobilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsImageWithParallax', SectionTitle?: string | null, MiniTitle?: string | null, MainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, MainImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, Covers: Array<{ __typename?: 'ComponentElementsParallexCover', id: string, X: number, Y: number, Speed: number, Cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | null> } | { __typename: 'ComponentSectionsLibrariesSection', Title: string, Items: Array<{ __typename?: 'ComponentElementsLibraryItem', Title: string, ButtonLink: string, Text: string, ButtonTitle: string, Background: string, IsFullWidth?: boolean | null, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> } | { __typename: 'ComponentSectionsLogoBoxes', LogoBoxtitle?: string | null, Logos: Array<{ __typename?: 'ComponentElementsLogoBox', LogoName?: string | null, LogoLink?: string | null, LogoImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> } | { __typename: 'ComponentSectionsPartnersForm', BigTitle: string, SmallText?: string | null, MainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsPlatformsSelector', Title: string, Platforms: Array<{ __typename?: 'ComponentElementsPlatformSelector', Title: string, Description: string, Link?: string | null, Background?: string | null, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> } | { __typename: 'ComponentSectionsPricing', Title: string, SmallSectionTitle?: string | null, pricing_categories?: { __typename?: 'PricingCategoryRelationResponseCollection', data: Array<{ __typename?: 'PricingCategoryEntity', attributes?: { __typename?: 'PricingCategory', Name: string, pricing_plans?: { __typename?: 'PricingPlanRelationResponseCollection', data: Array<{ __typename?: 'PricingPlanEntity', attributes?: { __typename?: 'PricingPlan', Title: string, ButtonLink: string, Badge?: string | null, BedgeBG?: string | null, ShowMonthly: boolean, MonthPrice: number, FirstMonthPrice?: string | null, EverythingInText?: string | null, Features: Array<{ __typename?: 'ComponentElementsPricingPlanFeature', Name: string, StrikedOut?: boolean | null } | null> } | null }> } | null } | null }> } | null } | { __typename: 'ComponentSectionsRichText', content: string } | { __typename: 'ComponentSectionsSlidingCoversHero', MainTitle?: string | null, Library: Enum_Componentsectionsslidingcovershero_Library, MainButton: { __typename?: 'ComponentLinksButton', text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null }, Covers: Array<{ __typename?: 'ComponentElementsSlidingCover', link?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> } | { __typename: 'ComponentSectionsTestimonialsSlider', Title: string, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', Title?: string | null, Sentence: string, Name: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSectionsTextAndButtonWithParallax', Text: string, Button?: { __typename?: 'ComponentLinksButton', text: string, dark: boolean, fullWidth: boolean, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug?: string | null } | null } | null } | null } | null, Covers: Array<{ __typename?: 'ComponentElementsParallexCover', id: string, X: number, Y: number, Speed: number, Cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | null> } | { __typename: 'ComponentSectionsTextAndImage', BigText: string, SmallDescription?: string | null, Direction: Enum_Componentsectionstextandimage_Direction, ImageSticked: boolean, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null }, MobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } | null } | { __typename: 'ComponentSectionsTracksParallaxBox', Title: string, Items: Array<{ __typename?: 'ComponentElementsTracksParallaxItem', Title: string, Genre: string, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, width?: number | null, height?: number | null, mime: string, url: string, formats?: any | null } | null } | null } } | null> } | { __typename: 'Error' } | null> | null } | null }> } | null };

export const FilePartsFragmentDoc = gql`
    fragment FileParts on UploadFileEntityResponse {
  data {
    id
    attributes {
      alternativeText
      width
      height
      mime
      url
      formats
    }
  }
}
    `;
export const GetGlobalDocument = gql`
    query GetGlobal($locale: I18NLocaleCode!) {
  mainNavigation: renderNavigation(
    navigationIdOrSlug: "main-navigation"
    type: TREE
    menuOnly: false
  ) {
    id
    title
    path
    related {
      id
      attributes {
        __typename
        ... on Page {
          shortName
        }
      }
    }
    items {
      id
      title
      path
      related {
        id
        attributes {
          __typename
          ... on Page {
            shortName
          }
        }
      }
    }
  }
  footerNavigation: renderNavigation(
    navigationIdOrSlug: "footer"
    type: TREE
    menuOnly: false
  ) {
    id
    title
    path
    related {
      id
      attributes {
        __typename
        ... on Page {
          shortName
        }
      }
    }
    items {
      id
      title
      path
      related {
        id
        attributes {
          __typename
          ... on Page {
            shortName
          }
        }
      }
    }
  }
  global(locale: $locale) {
    data {
      id
      attributes {
        iOSStoreLink
        GooglePlayStoreLink
        metadata {
          favicon {
            ...FileParts
          }
          metaTitle
          metaDescription
          shareImage {
            ...FileParts
          }
          twitterCardType
          twitterUsername
          GoogleTagManagerID
          FacebookPixeliD
          klaviyoApiKey
          accent
        }
        metaTitleSuffix
        Copyrights
      }
    }
  }
}
    ${FilePartsFragmentDoc}`;

/**
 * __useGetGlobalQuery__
 *
 * To run a query within a React component, call `useGetGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetGlobalQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalQuery, GetGlobalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalQuery, GetGlobalQueryVariables>(GetGlobalDocument, options);
      }
export function useGetGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalQuery, GetGlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalQuery, GetGlobalQueryVariables>(GetGlobalDocument, options);
        }
export type GetGlobalQueryHookResult = ReturnType<typeof useGetGlobalQuery>;
export type GetGlobalLazyQueryHookResult = ReturnType<typeof useGetGlobalLazyQuery>;
export type GetGlobalQueryResult = Apollo.QueryResult<GetGlobalQuery, GetGlobalQueryVariables>;
export const GetPagesDocument = gql`
    query GetPages($slug: String!, $publicationState: PublicationState!) {
  pages(filters: {slug: {eq: $slug}}, publicationState: $publicationState) {
    data {
      id
      attributes {
        slug
        ShowFooter
        ShowNavigation
        RedirectOnSubscription
        RedirectionTarget
        metadata {
          favicon {
            ...FileParts
          }
          metaTitle
          metaDescription
          shareImage {
            ...FileParts
          }
          twitterCardType
          twitterUsername
          FacebookPixeliD
          GoogleTagManagerID
          accent
          ShowZendeskChat
          ZendeskChatTagId
        }
        contentSections {
          __typename
          ... on ComponentSectionsHero {
            id
            action {
              transparent
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            ActionTwo {
              transparent
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            isPromotionForm
            marketingPlatform
            marketingType
            title
            text
            CubeBackgroundColor {
              color
            }
            mobileTitle
            picture {
              ...FileParts
            }
            mobilePicture {
              ...FileParts
            }
          }
          ... on ComponentSectionsForgotPassword {
            Title
            ResetTitle
            SmallText
            ResetText
            Image {
              ...FileParts
            }
            ResetImage {
              ...FileParts
            }
          }
          ... on ComponentSectionsCallToAction {
            bigTitle
            smallTitle
            action {
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            image {
              ...FileParts
            }
            background
          }
          ... on ComponentSectionsFaq {
            BigTitle
            SmallTitle
            questions {
              Answer
              Question
            }
          }
          ... on ComponentSectionsTestimonialsSlider {
            Title
            testimonials {
              data {
                attributes {
                  Title
                  Sentence
                  Name
                  Image {
                    ...FileParts
                  }
                }
              }
            }
          }
          ... on ComponentSectionsDataTilesGrid {
            Title
            Tiles {
              Title
              Image {
                ...FileParts
              }
              Link
              Size
              Text
              MobileImage {
                ...FileParts
              }
            }
          }
          ... on ComponentSectionsFeaturesScrollSection {
            InnerTitle
            ImageType
            SideLineColor
            MainTitle
            KeepSliderOnMobile
            Features {
              Text
              Image {
                ...FileParts
              }
              Title
              Background
              ButtonDisabled
              ButtonLink
              ButtonText
              MobileImage {
                ...FileParts
              }
            }
          }
          ... on ComponentSectionsLibrariesSection {
            Title
            Items {
              Title
              ButtonLink
              Image {
                ...FileParts
              }
              Text
              ButtonTitle
              Background
              IsFullWidth
            }
          }
          ... on ComponentSectionsFeaturesCards {
            BigTitle
            SmallTitle
            TopLeftCard {
              Title
              Text
              Image {
                ...FileParts
              }
              MobileImage {
                ...FileParts
              }
              Link
            }
            TopRightCard {
              Title
              Text
              Image {
                ...FileParts
              }
              MobileImage {
                ...FileParts
              }
              Link
            }
            BottomLeftCard {
              Title
              Text
              Image {
                ...FileParts
              }
              MobileImage {
                ...FileParts
              }
              Link
            }
            BottomRight {
              Title
              Text
              Image {
                ...FileParts
              }
              MobileImage {
                ...FileParts
              }
              Link
            }
          }
          ... on ComponentSectionsGetTheApp {
            Image {
              ...FileParts
            }
            Background
            SmallTitle
            BigTitle
          }
          ... on ComponentSectionsTracksParallaxBox {
            Title
            Items {
              Title
              Image {
                ...FileParts
              }
              Genre
            }
          }
          ... on ComponentSectionsPricing {
            Title
            SmallSectionTitle
            pricing_categories {
              data {
                attributes {
                  Name
                  pricing_plans {
                    data {
                      attributes {
                        Title
                        ButtonLink
                        Features {
                          Name
                          StrikedOut
                        }
                        Badge
                        BedgeBG
                        ShowMonthly
                        MonthPrice
                        FirstMonthPrice
                        EverythingInText
                      }
                    }
                  }
                }
              }
            }
          }
          ... on ComponentSectionsRichText {
            content
          }
          ... on ComponentSectionsFormAndImage {
            Image {
              ...FileParts
            }
            MobileImage {
              ...FileParts
            }
            Layout
            SmallText
            Title
            Type
            PromoCode
            OfferDisclaimer
            From
            RecaptchaSiteToken
            LoginLink
            ForceRedirectTo
          }
          ... on ComponentSectionsPlatformsSelector {
            Title
            Platforms {
              Title
              Description
              Image {
                ...FileParts
              }
              Link
              Background
            }
          }
          ... on ComponentSectionsImageWithParallax {
            SectionTitle
            MiniTitle
            MainImage {
              ...FileParts
            }
            MainImageMobile {
              ...FileParts
            }
            Covers {
              id
              Cover {
                ...FileParts
              }
              X
              Y
              Speed
            }
          }
          ... on ComponentSectionsGenresRunner {
            Headline
            FirstRow {
              Genre
              Image {
                ...FileParts
              }
            }
            SecondRow {
              Genre
              Image {
                ...FileParts
              }
            }
            ThirdRow {
              Genre
              Image {
                ...FileParts
              }
            }
          }
          ... on ComponentSectionsContentHero {
            TitleBig
            TitleSmall
            StyledTitle
            UseAppStoreLinks
            BigMainImage {
              ...FileParts
            }
            BigMainImageMobile {
              ...FileParts
            }
            FullWidthBg {
              ...FileParts
            }
            Button {
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            Button2 {
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
          }
          ... on ComponentSectionsTextAndImage {
            BigText
            SmallDescription
            Direction
            ImageSticked
            Image {
              ...FileParts
            }
            MobileImage {
              ...FileParts
            }
          }
          ... on ComponentSectionsTextAndButtonWithParallax {
            Text
            Button {
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            Covers {
              id
              Cover {
                ...FileParts
              }
              X
              Y
              Speed
            }
          }
          ... on ComponentSectionsGetTheAppWithIcon {
            Title
            Icon {
              ...FileParts
            }
          }
          ... on ComponentSectionsLogoBoxes {
            LogoBoxtitle
            Logos {
              LogoName
              LogoLink
              LogoImage {
                ...FileParts
              }
            }
          }
          ... on ComponentSectionsPartnersForm {
            BigTitle
            SmallText
            MainImage {
              ...FileParts
            }
            MobileImage {
              ...FileParts
            }
          }
          ... on ComponentSectionsGiveaway {
            GiveawaySlug
            SignupLink {
              data {
                attributes {
                  slug
                }
              }
            }
          }
          ... on ComponentSectionsSlidingCoversHero {
            MainTitle
            MainButton {
              text
              dark
              fullWidth
              page {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
            Covers {
              link
              cover {
                ...FileParts
              }
            }
            Library
          }
        }
      }
    }
  }
}
    ${FilePartsFragmentDoc}`;

/**
 * __useGetPagesQuery__
 *
 * To run a query within a React component, call `useGetPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetPagesQuery(baseOptions: Apollo.QueryHookOptions<GetPagesQuery, GetPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPagesQuery, GetPagesQueryVariables>(GetPagesDocument, options);
      }
export function useGetPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPagesQuery, GetPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPagesQuery, GetPagesQueryVariables>(GetPagesDocument, options);
        }
export type GetPagesQueryHookResult = ReturnType<typeof useGetPagesQuery>;
export type GetPagesLazyQueryHookResult = ReturnType<typeof useGetPagesLazyQuery>;
export type GetPagesQueryResult = Apollo.QueryResult<GetPagesQuery, GetPagesQueryVariables>;